import { render, staticRenderFns } from "./AsignarArticulos.vue?vue&type=template&id=4e72d71e&scoped=true"
import script from "./AsignarArticulos.vue?vue&type=script&lang=js"
export * from "./AsignarArticulos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e72d71e",
  null
  
)

export default component.exports